<div
  class="tf-reactions-bar"
  [attr.aria-label]="'COMMENTS.REACTIONS.GROUP_ARIA' | translate">
  @for (reaction of reactions(); track reaction.emoji) {
    <button
      type="button"
      class="tf-reactions-bar__chip"
      [class.tf-reactions-bar__chip--reacted]="reaction.youReacted"
      [disabled]="!canReact()"
      [attr.aria-pressed]="reaction.youReacted"
      [attr.aria-label]="
        (reaction.youReacted
          ? 'COMMENTS.REACTIONS.CHIP_ARIA_REACTED'
          : 'COMMENTS.REACTIONS.CHIP_ARIA_NOT_REACTED'
        ) | translate: { emoji: reaction.emoji, count: reaction.count }
      "
      [attr.title]="
        (reaction.youReacted
          ? 'COMMENTS.REACTIONS.CHIP_ARIA_REACTED'
          : 'COMMENTS.REACTIONS.CHIP_ARIA_NOT_REACTED'
        ) | translate: { emoji: reaction.emoji, count: reaction.count }
      "
      (click)="onChipClick(reaction.emoji)">
      <span class="tf-reactions-bar__emoji" aria-hidden="true">{{ reaction.emoji }}</span>
      <span class="tf-reactions-bar__count" aria-hidden="true">{{ reaction.count }}</span>
    </button>
  }
  @if (canReact()) {
    <button
      type="button"
      class="tf-reactions-bar__add"
      [attr.aria-label]="'COMMENTS.REACTIONS.ADD_ARIA' | translate"
      [attr.title]="'COMMENTS.REACTIONS.ADD_ARIA' | translate"
      (click)="onAddClick($event)">
      <tf-react-icon />
    </button>
  }
</div>
